// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
window.bootstrap = bootstrap

import { TabulatorFull as Tabulator } from 'tabulator-tables';
window.Tabulator = Tabulator;

import '@fortawesome/fontawesome-free/js/all';

import "./src/jquery"
import "./src/jquery-ui"
// Import individual JS-Files
import "./src/custom"

// Import Maps-JS-Files
import "./maps/gmaps"
import "./maps/index"




// $(function () {
//     // console.log("hello world")
//     // $("#dialog").dialog();
//     // $(document).tooltip();
//     // $("#tabs").tabs();
// })

// Ergänzung einer HTML-Klasse für die Login-Seite (sessions/new)
// if ($(".sessions.new").length) {
//     $("div:nth-child(1)").addClass("login-page");
// }
